import { render, staticRenderFns } from "./TapIndex.vue?vue&type=template&id=c8afe7b2&scoped=true&"
import script from "./TapIndex.vue?vue&type=script&lang=js&"
export * from "./TapIndex.vue?vue&type=script&lang=js&"
import style0 from "./TapIndex.vue?vue&type=style&index=0&id=c8afe7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8afe7b2",
  null
  
)

export default component.exports